module.exports = __webpack_public_path__ + "img/48.6181c698.jpg";